import { Component, ElementRef, OnInit } from '@angular/core';
import { RelatorioResource } from 'src/app/interface/RelatorioResouce';
import { HttpService } from '../../service/http.service';
import { Message } from '../../enum/message';
import { ToastrService } from 'ngx-toastr';
import { Moment } from 'moment';
import Swal from 'sweetalert2';
import { RelatorioGeralResource } from 'src/app/interface/RelatorioGeralResource';
import { $ } from 'protractor';

@Component({
  selector: 'app-relatorio',
  templateUrl: './relatorio.component.html',
  styleUrls: ['./relatorio.component.css'],
})
export class RelatorioComponent implements OnInit {

  loaded: boolean = false;

  err: boolean = false;

  noRecords: boolean = false;

  message: Message;

  grafico: [];

  filterDate: { begin: Moment, end: Moment};

  constructor(private httpService: HttpService, private toastr: ToastrService) { }

  labelBar: string[] = [];

  valueBar: number[] = [];

  titulo: string = "Custos Totais";

  ngOnInit() {
    this.getRelatorio("", "");
  }

  getRelatorio(begin: string, end: string) {
    this.httpService.getRelatorio(begin, end).subscribe(
      (resposta: RelatorioResource[]) => {
        const res: RelatorioResource[] = resposta;

        if (res.length === 0) {
          this.message = Message.NO_RECORDS;
          this.noRecords = true;
          this.loaded = true;
          return;
        }
        let labelRelatorio: string[] = [];
        let valueRelatorio: number[] = [];

        res.map((resultado) => {
          labelRelatorio.push(resultado.data);
          valueRelatorio.push(Number.parseFloat(resultado.valorExtra.toFixed(2)));
        });

        console.log(labelRelatorio);
        console.log(valueRelatorio);

        this.labelBar = labelRelatorio;
        this.valueBar = valueRelatorio;

        this.loaded = true;
      },
      (error) => {
        console.log("Erro", error);
        this.toastr.error('Falha ao carregar os dados.');
        this.message = Message.ERROR;
        this.loaded = true;
        this.err = true;
      }
    );
  }

  filtrar()
  {
    this.loaded = false;
    this.getRelatorio(this.filterDate.begin.format('YYYY-MM-DD'), this.filterDate.end.format('YYYY-MM-DD'));
  }

  onRelatorio(relatorio: string) {
    this.httpService.getRelatorioDetalhes(relatorio, this.titulo).subscribe(
      (resposta: RelatorioGeralResource[]) => {

        var html = "<div class='table-responsive'><table>";
        html += "<tr><th>CAB</th><th>CONTAINER</th><th>SERVIÇO</th><th>VALOR</th><th>DATA ORIGEM</th><th>DATA DESTINO</th></tr>";
        resposta.forEach(function(relatorio, index) {
          var dataInicio = new Date(Date.parse(relatorio.dataInicio));
          var dataFim = new Date(Date.parse(relatorio.dataFim));
          html += "<tr>";
          html += "<td>" + relatorio.cab + "</td>"
          html += "<td>" + relatorio.container + "</td>"
          html += "<td>" + relatorio.servico + "</td>"
          html += "<td>R$" + relatorio.valorExtra.toFixed(2).replace('.', ',') + "</td>"
          html += "<td>" + dataInicio.toLocaleDateString() + "</td>"
          html += "<td>" + dataFim.toLocaleDateString() + "</td>"
          html += "</tr>";
        });

        html+= "</table></div>";

        Swal.fire({
          title: 'Detalhes por serviço em ' + relatorio,
          html: html,
          icon: "info",
          showCloseButton: true,
          showConfirmButton: false,
          width: 1200
        })
      });

  }

  exportar()
  {
    if(this.filterDate != undefined)
    {
      this.httpService.getFileRelatorio(this.filterDate.begin.format('YYYY-MM-DD'), this.filterDate.end.format('YYYY-MM-DD')).subscribe((resposta: any) =>
      {
        this.onBlob(resposta);
      })
    }
    else
    {
      this.httpService.getFileRelatorio("", "").subscribe((resposta: any) =>
      {
        this.onBlob(resposta);

      })
    }
  }

  onBlob(resposta) {
    const blob = new Blob([resposta], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); // you can change the type
    const fileName: string =  this.titulo + '.xlsx';
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;

    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }

}
